import { CommonButton } from '@Components/common/Button';
import styled, { css } from 'styled-components';
import { mq, rgba } from 'stylesheets/utils';
export const Wrapper = styled.div<{
  readonly smallPadding?: boolean;
  readonly reservation?: boolean;
}>`
  width: 100%;
  min-height: calc(100vh - 130px);
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 43px;
  ${mq(768)} {
    padding: 20px;
  }
  ${({ smallPadding }) =>
    smallPadding &&
    css`
      padding: 30px 10px;
    `}
  ${({ reservation }) =>
    reservation &&
    css`
      padding: 25px 50px;
    `}
`;

export const AddNew = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.auth.blue};
  cursor: pointer;
  margin: 12px 0;
`;

export const AddNewIcon = styled.div`
  max-width: 30px;
  min-width: 30px;
  max-height: 30px;
  min-height: 30px;
  margin-right: 14px;
`;

export const Overlay = styled.div<{ readonly isActive?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => rgba(theme.colors.darkBlue, 0.7)};
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: 0.2s ease opacity, 0.2s ease visibility;
  transition-delay: 0.1s, 0.1s;
  z-index: 8;
  ${({ isActive }) =>
    isActive &&
    css`
      transition-delay: 0s, 0s;
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
    `}
`;

export const DeclineWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.brandColor};
  font-size: ${({ theme }) => theme.fontsizes.body14};
`;

export const DeclineIcon = styled.div`
  max-width: 24px;
  min-width: 24px;
  max-height: 24px;
  min-height: 24px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DeclineArrow = styled(DeclineIcon)`
  margin-right: 0;
  margin-left: 40px;
  transform: scale(-1, 1) /*rtl: 0 */;
`;

// hotline
export const Btn = styled(CommonButton)`
  width: 222px;
  max-height: 48px;
  line-height: 48px;
  margin: 0 auto;
  font-size: 3rem;
  font-weight: ${({ theme }) => theme.fontWeight.font600};
`;

//customer service

export const P = styled.p<{
  readonly red?: boolean;
}>`
  width: 100%;
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  margin-bottom: 24px;
  a {
    font-size: inherit;
    color: inherit;
    font-weight: ${({ theme }) => theme.fontWeight.font500};
  }
  &:last-of-type {
    margin-bottom: 34px;
  }
  ${({ red }) =>
    red &&
    css`
      color: ${({ theme }) => theme.colors.brandColor};
      font-size: ${({ theme }) => theme.fontsizes.h6};
    `}
`;

export const ContactBtn = styled(Btn)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.fontsizes.body16};
  margin: 0;
`;

export const ContactIcon = styled.div`
  max-width: 27.31px;
  min-width: 27.31px;
  max-height: 32px;
  min-height: 32px;
  margin-right: 16px;
`;

export const Div = styled.div`
  /* max-width: 735px; */
  width: 100%;
  height: 100%;
`;
